import React from 'react';
import { ArrowRight, Download, Smartphone, TrendingUp, AlertCircle } from 'lucide-react';
import { PaymentIcons } from './PaymentIcons';
export function HeroSection() {
  return <>
      {/* Top navigation bar */}
      <header className="w-full bg-teal-800 py-2 px-4" data-id="element-92">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-93">
          <h1 className="text-white text-xl font-bold" data-id="element-94">EAT TO HEAL</h1>
          <p className="text-white text-xs font-medium" data-id="element-95">
            Nutrition that heals from within
          </p>
        </div>
      </header>
      {/* Main hero section */}
      <section className="w-full bg-teal-50 py-16 px-4" data-id="element-96">
        <div className="max-w-6xl mx-auto" data-id="element-97">
          <div className="flex flex-col md:flex-row items-center" data-id="element-98">
            {/* Left column - Text content */}
            <div className="w-full md:w-1/2 mb-10 md:mb-0 md:pr-8" data-id="element-99">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-100">
                EAT TO <span className="text-teal-700" data-id="element-101">HEAL</span>
              </h2>
              <h3 className="text-2xl md:text-3xl font-semibold text-gray-700 mb-8 leading-snug" data-id="element-102">
                They told you it's genetic. That you'll need meds forever. But
                the real cause… is hiding in your kitchen.
              </h3>
              <div className="border-l-4 border-teal-700 pl-4 mb-8" data-id="element-103">
                <h4 className="text-xl font-medium text-gray-800 mb-2" data-id="element-104">
                  Your body isn't broken. It's inflamed — and food can fix it.
                  This recipe book shows you how to reverse high cholesterol and
                  blood sugar… naturally.
                </h4>
              </div>
              <p className="text-lg text-gray-700 mb-8" data-id="element-105">
                Discover the method proven by over 5,000 people who are{' '}
                <span className="font-semibold" data-id="element-106">
                  reclaiming their health from their kitchen
                </span>
                , without extreme diets or impossible sacrifices.
              </p>
              <a href="https://ebooksociety.co/cart/51407721562393:1?checkout" className="bg-teal-700 hover:bg-teal-800 text-white font-medium py-3 px-6 rounded-md flex items-center transition cursor-pointer" data-id="element-107">
                Get Your Recipe eBook Now
                <ArrowRight size={18} className="ml-2" data-id="element-108" />
              </a>
            </div>
            {/* Right column - Product image */}
            <div className="w-full md:w-1/2 relative" data-id="element-109">
              <div className="relative" data-id="element-110">
                <div className="bg-white p-6 rounded-md shadow-xl" data-id="element-111">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pUz2ycH78DhCGCtiWuR8CA/ChatGPT_Image_27_sept_2025%2C_23_41_42.webp" alt="EAT TO HEAL: The Anti-Cholesterol & Anti-Sugar Cookbook That Could Save Your Life" className="w-full h-auto rounded-md" data-id="element-112" />
                  {/* Nueva sección CTA según la imagen proporcionada */}
                  <div className="mt-6" data-id="element-113">
                    {/* Precios */}
                    <div className="flex justify-center items-center mb-6" data-id="element-114">
                      <span className="text-gray-500 line-through text-xl" data-id="element-115">
                        $39 USD
                      </span>
                      <span className="text-4xl font-bold text-gray-900 ml-4" data-id="element-116">
                        $19 USD
                      </span>
                    </div>
                    {/* Mensaje de oferta limitada */}
                    <div className="bg-gray-100 py-4 px-6 flex items-start mb-6 rounded" data-id="element-117">
                      <AlertCircle size={20} className="text-gray-600 mr-2 flex-shrink-0 mt-1" data-id="element-118" />
                      <p className="text-gray-700 text-left" data-id="element-119">
                        <span className="font-semibold" data-id="element-120">
                          Limited time offer!
                        </span>{' '}
                        After 200 copies sold, the price will return to $39 USD
                      </p>
                    </div>
                    {/* Beneficios */}
                    <div className="mb-6" data-id="element-121">
                      <div className="flex items-center py-3" data-id="element-122">
                        <Download size={20} className="text-gray-700 mr-3" data-id="element-123" />
                        <p className="text-gray-800" data-id="element-124">Immediate download</p>
                      </div>
                      <div className="flex items-center py-3" data-id="element-125">
                        <Smartphone size={20} className="text-gray-700 mr-3" data-id="element-126" />
                        <p className="text-gray-800" data-id="element-127">Access from any device</p>
                      </div>
                      <div className="flex items-center py-3" data-id="element-128">
                        <TrendingUp size={20} className="text-gray-700 mr-3" data-id="element-129" />
                        <p className="text-gray-800" data-id="element-130">
                          Improvement from the first week
                        </p>
                      </div>
                    </div>
                    {/* FREE BONUSES Banner */}
                    <div className="bg-teal-50 py-3 px-4 mb-6 border-l-4 border-teal-600 rounded" data-id="element-131">
                      <p className="text-teal-700 font-bold text-center" data-id="element-132">
                        Includes 2 FREE BONUSES
                      </p>
                    </div>
                    {/* CTA Button */}
                    <a href="https://ebooksociety.co/cart/51407721562393:1?checkout" className="w-full bg-orange-600 hover:bg-orange-700 text-white font-bold py-4 px-6 rounded-lg text-xl transition inline-block text-center shadow-lg mb-4" data-id="element-133">
                      Download Eat To Heal Now
                    </a>
                    {/* Payment Icons */}
                    <PaymentIcons data-id="element-134" />
                    {/* Final note */}
                    <p className="text-gray-500 text-sm text-center mt-4 mb-2" data-id="element-135">
                      One-time payment. No subscriptions or hidden charges.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <style jsx data-id="element-136">{`
        @keyframes subtlePulse {
          0%,
          100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.03);
          }
        }
        .animate-subtle-pulse {
          animation: subtlePulse 3s infinite ease-in-out;
        }
      `}</style>
    </>;
}